// src/belediye/services/yonetimApi.js
//
// FAZ-24 — yeni yönetim ekranları servis katmanı: Mahalleler (core_app),
// Vatandaşlar (core_app, KVKK) ve İdari Sınırlar (bm4). Tümü GLOBAL (birim-bağımsız)
// uçlar → belediyeApi.js `isNoUnitHeaderEndpoint` listesinde X-Unit-Slug'tan muaf.
// Konvansiyon (sistemApi.js ile birebir): kısa arrow + .then(); update = PATCH;
// path'ler trailing-slash'lı; hata YUTULMAZ (component try/catch).

import api from "./belediyeApi";

// null/undefined/"" param'ları query'den at
const clean = (obj) =>
  obj && typeof obj === "object"
    ? Object.fromEntries(
        Object.entries(obj).filter(([, v]) => v !== undefined && v !== null && v !== "")
      )
    : obj;

// DRF sayfalı ({results}) VEYA düz dizi → her zaman düz dizi
const asList = (data) =>
  Array.isArray(data?.results) ? data.results : Array.isArray(data) ? data : [];

// ─────────────────────────────────────────────────────────────
//  MAHALLELER — /api/core/neighborhoods/  (read AllowAny, write neighborhoods.*)
//  Alanlar: { id, name }.  DELETE = hard (FK'ler SET_NULL).
// ─────────────────────────────────────────────────────────────
export const fetchNeighborhoods = () =>
  api.get("/core/neighborhoods/").then((r) => asList(r.data));

export const createNeighborhood = (payload) =>
  api.post("/core/neighborhoods/", payload).then((r) => r.data);

export const updateNeighborhood = (id, payload) =>
  api.patch(`/core/neighborhoods/${id}/`, payload).then((r) => r.data);

export const deleteNeighborhood = (id) =>
  api.delete(`/core/neighborhoods/${id}/`).then((r) => r.data);

// ─────────────────────────────────────────────────────────────
//  VATANDAŞLAR (KVKK) — /api/core/citizens-admin/  (gate: citizens.*)
//  Liste SUNUCU-tarafı sayfalı (page_size=25) + q araması (ad/soyad/telefon).
//  Telefon AYRI uç (citizens.phone.update); DELETE soft + yalnız superuser.
//  Alanlar: { id, name, surname, phone_number, email }.
// ─────────────────────────────────────────────────────────────
export const fetchCitizens = (params = {}) =>
  api.get("/core/citizens-admin/", { params: clean(params) }).then((r) => r.data); // {count,next,previous,results}

export const fetchCitizen = (id) =>
  api.get(`/core/citizens-admin/${id}/`).then((r) => r.data);

export const createCitizen = (payload) =>
  api.post("/core/citizens-admin/", payload).then((r) => r.data);

// PATCH — telefon HARİÇ (backend read_only); {name?, surname?, email?}
export const updateCitizen = (id, payload) =>
  api.patch(`/core/citizens-admin/${id}/`, payload).then((r) => r.data);

// Telefon AYRI gate + audit; {phone_number} (10 hane rakam)
export const updateCitizenPhone = (id, phone_number) =>
  api.post(`/core/citizens-admin/${id}/phone/`, { phone_number }).then((r) => r.data);

// Vatandaşın başvuruları — düz dizi [{basvuru_no,konu,durum,birim,tarih}]
export const fetchCitizenApplications = (id) =>
  api.get(`/core/citizens-admin/${id}/applications/`).then((r) => asList(r.data));

// Soft-delete (is_active=False), yalnız superuser (backend zorlar) → 204
export const deleteCitizen = (id) =>
  api.delete(`/core/citizens-admin/${id}/`).then((r) => r.data);

// ─────────────────────────────────────────────────────────────
//  İDARİ SINIRLAR — /api/bm4/boundaries/  (read IsAuthenticated, write admin_boundaries.*)
//  APIView tabanlı; liste {count, results, applied_filters} zarfı döner (asList değil).
//  DELETE = soft (is_active=False). Import gövdesi JSON (FormData DEĞİL).
// ─────────────────────────────────────────────────────────────
export const fetchBoundaries = (params = {}) =>
  api.get("/bm4/boundaries/", { params: clean(params) }).then((r) => r.data); // {count,results,applied_filters}

export const fetchBoundary = (id, params = {}) =>
  api.get(`/bm4/boundaries/${id}/`, { params: clean(params) }).then((r) => r.data);

export const createBoundary = (payload) =>
  api.post("/bm4/boundaries/", payload).then((r) => r.data);

export const updateBoundary = (id, payload) =>
  api.patch(`/bm4/boundaries/${id}/`, payload).then((r) => r.data);

// Soft-delete (is_active=False, is_default temizlenir) → 204
export const deleteBoundary = (id) =>
  api.delete(`/bm4/boundaries/${id}/`).then((r) => r.data);

// Dışa aktar — FeatureCollection (indirilecek JSON)
export const exportBoundaries = () =>
  api.get("/bm4/boundaries/export/").then((r) => r.data);

// İçe aktar — JSON gövde: FeatureCollection VEYA {boundaries:[]} (upsert).
// Dönüş: {created, updated, error_count, errors}
export const importBoundaries = (body) =>
  api.post("/bm4/boundaries/import/", body).then((r) => r.data);
